import useEvent from '@lyearn/core/hooks/useEvent';
import useToggle from '@lyearn/core/hooks/useToggle';
import { NewFilterOption } from '@/components/FilterNew/types';

import { BaseEntityFilterProps } from '../types';
import EntityFilter from '.';

const BaseEntityFilter: React.FC<React.PropsWithChildren<BaseEntityFilterProps>> = (props) => {
  const { filter, setFilter, id, open, onToggle, children, ...rest } = props;
  const [isOpen, { toggle }] = useToggle(false);

  const { adaptSelectedFilterItemsToState } = rest.listConfig;

  const getAdaptedState = (items: NewFilterOption[], id: string) => {
    return adaptSelectedFilterItemsToState
      ? adaptSelectedFilterItemsToState(items, id, filter)
      : { [id]: items.map((i) => i.value) };
  };

  const onChange = useEvent((values: NewFilterOption[]) => {
    const adaptedState = getAdaptedState(values, id);
    setFilter({
      ...filter,
      ...adaptedState,
    });
    // ideally onChange should only change the values, but everywhere onToggle is called inside onChange
    // so we need to call it here as well, need to ask @harshit @iamsaumya
    onToggle?.(false);
    toggle();
  });

  const selectedOptions = filter[id] ?? [];
  const openingData = onToggle ? { open, onToggle } : { open: isOpen, onToggle: toggle };

  return (
    <EntityFilter
      open={openingData.open}
      onChange={onChange}
      onToggle={openingData.onToggle}
      {...rest}
      initialSelectedOptions={selectedOptions as string[]}>
      {children}
    </EntityFilter>
  );
};

export default BaseEntityFilter;
